import { Card, CardContent, Typography } from '@mui/material';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { tipoDeMedio } from 'constantes/globalsStates';
import DetalleDeLaPantalla from 'pages/catalogosDeMedios/detalle/DetalleDeLaPantalla';
import DetalleDeLaVallaFija from 'pages/catalogosDeMedios/detalle/DetalleDeLaVallaFija';
import DetalleDeLaVallaMovil from 'pages/catalogosDeMedios/detalle/DetalleDeLaVallaMovil';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { obtenerInformacionPublica } from 'store/actions/customAction';
import styles from 'styles/informacionDelCard';

const ValidarInformacionQR = () => {
    const { codigoUnico } = useParams();
    const dispatch = useDispatch()
    const  classes = styles();

    const [indicadorDeCarga, setearIndicadorDeCarga] = useState(false);
    const [informacionQR, setearInformacionQR] = useState(false);
    const [datosDelQR, setDatosDelQR] = useState([]);
    const [mensajeDeError, setearMensajeDeError] = useState("");

    useEffect(() => {
        obtenerInformacionCaratula()
    }, []);

    const obtenerInformacionCaratula = async () => {
        setearIndicadorDeCarga(true);
        setDatosDelQR(false);

        const dataCustomFetch = { controller: "catalogoDeMediosPublicos", action: `validarMedioDeComunicacion/${codigoUnico}`, }

        const response = await dispatch(obtenerInformacionPublica(dataCustomFetch));

        setearIndicadorDeCarga(false);

        if(response?.error){
            setearInformacionQR(true);
            return setearMensajeDeError(response?.error?.message || "Inconvenientes para obtener información del QR")
        }

        if(response?.data?.length === 0 ){
            setearInformacionQR(true);
            return setearMensajeDeError(response?.error?.message || 'CÓDIGO NO VÁLIDO')
        }
        if(!response?.data){
            setearInformacionQR(true);
            return setearMensajeDeError('','CÓDIGO NO VÁLIDO')
        }

        setDatosDelQR(response?.data);
        setearInformacionQR(true);
    }

    if(indicadorDeCarga) return <IndicadorDeCarga open={indicadorDeCarga}/>

    const {medioDeComunicacion} = datosDelQR;

    const validarTipoDeMedio = () => {
      switch (medioDeComunicacion?.tipoDeMedioDeComunicacion.id) {
        case tipoDeMedio["pantallas"]: return ( <DetalleDeLaPantalla datosDelMedioSeleccionado={datosDelQR} /> )
        case tipoDeMedio["vallasFijas"]: return ( <DetalleDeLaVallaFija datosDelMedioSeleccionado={datosDelQR} /> )
        default: return ( <DetalleDeLaVallaMovil datosDelMedioSeleccionado={datosDelQR} /> )
      }
    }

    return (
        <Card className={classes.root}>
            <CardContent>
            {informacionQR && (
                <>
                    {datosDelQR ? (
                        <>
                          <h1 className={classes.titleAlerta}>Sistema Integrado de Distribución Igualitaria (SIDI)</h1>
                          {validarTipoDeMedio()}
                        </>
                    ) : ( <>
                            <h1 className={classes.titleAlerta}>Sistema Integrado de Distribución Igualitaria (SIDI)</h1>
                            <Typography variant='h6' style={{textAlign: 'center', margin: '30px 0px', lineHeight: "27px"}}  > {mensajeDeError || ""}</Typography>
                        </>)
                    }
                </>
            )}
            </CardContent>
        </Card>
    )
}

export default ValidarInformacionQR;